import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeWatcher: {
		id: 'issue-view-watchers.watchers.dropdown.watchers-list.users-list.user-item.remove-watcher',
		defaultMessage: 'Remove watcher',
		description: 'aria label for icon for removing a watcher from an issue',
	},
});
